<template>
    <div class="main-container">
        <div class="main-container-title-box">
            <div class="main-container-title-box-text">
                <span class="title-box-text">
                    Состав консультационного совета акционеров
                </span>
                <v-icon @mouseover="openInfo($event)" @mouseleave="showInfo = false"
                    color="var(--app-dark-blue-1)">mdi-information</v-icon>
            </div>
            <v-btn @click="goToCreate" style="width: auto !important" class=" button-accept">
                + Добавить акционера
            </v-btn>
        </div>

        <v-menu v-model="showInfo" :position-x="x" :position-y="y" absolute offset-y>
            <v-card min-width="300px" min-height="100px">
                <div class="menu-container">
                    <div class="menu-container-title">
                        «Состав консультационного совета акционеров»
                    </div>
                    <div class="menu-container-text">
                        Список акционеров, который отображается в мобильном приложении
                    </div>

                </div>

            </v-card>
        </v-menu>

        <div>

            <v-data-table :headers="tableHeaders" :items="items" item-key="id" :show-select="false"
                :disable-pagination="true" :hide-default-footer="true">

                <template v-slot:body="props">
                    <draggable :list="props.items" tag="tbody" @end="endDrag" :move="checkMove"
                        :style="moveItems ? 'pointer-events: none;' : ''">
                        <tr v-for="(item, index) in props.items" :key="index" @click="goToDetail(item)">
                            <td>
                                <v-icon small style="cursor: pointer" :disabled="moveItems ? true : false">
                                    mdi-menu
                                </v-icon>
                            </td>
                            <td> {{ index + 1 }} </td>
                            <td>
                                {{ item.fullName }}
                            </td>


                        </tr>
                    </draggable>
                </template>

            </v-data-table>


        </div>
        <v-divider></v-divider>
    </div>
</template>
<script>

import draggable from "vuedraggable";
export default {
    components: {
        draggable
    },
    data: () => ({
        showInfo: false,
        x: null,
        y: null,
        items: [],
        moveItems: false,
        selectedDrag: '',
        tableHeaders: [
            {
                text: '',
                sortable: false
            },
            {
                text: 'Порядок отображения',
                value: '',
                sortable: false
            },
            {
                text: 'ФИО',
                sortable: false,
                value: 'fullName',
            },


        ],
    }),
    methods: {
        openInfo(e) {

            e.preventDefault()

            this.x = e.clientX + 10
            this.y = e.clientY + 10
            this.showInfo = true
        },
        goToCreate() {
            this.$router.push({ name: 'CreateShareholder' })

        },
        goToDetail(item) {
            this.$router.push({ name: 'DetailShareholder', params: { id: item.id } })

        },
        getShareholders() {
            this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/shareholder/list', {


            }, {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                }
            })
                .then(res => {

                    this.items = res.data.items

                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },
        endDrag(evt) {
            this.moveItems = true
            this.$axios.put(this.$store.getters.apiAdminPanelV2 + '/shareholder/sort', {
                shareholderId: this.selectedDrag,
                index: evt.newIndex + 1

            }, {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                }
            })
                .then(() => {
                    this.getShareholders()
                    this.moveItems = false


                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },
        checkMove(evt) {
            this.selectedDrag = evt.draggedContext.element.id
        },
    },
    created() {
        this.getShareholders()
    },
}
</script>
<style lang="scss" scoped></style>